export default "__VITE_ASSET__DjNgnYu3__"